export interface AppRouteDefinition {
  path: string
  label: string
}

export const PUBLIC_ROUTES: AppRouteDefinition[] = [
  { path: '/', label: 'Landing' },
  { path: '/login', label: 'Login' },
  { path: '/reset-password', label: 'Reset password' },
]

export const ONBOARDING_ROUTE: AppRouteDefinition = {
  path: '/onboarding',
  label: 'Onboarding',
}

export const PROTECTED_APP_ROUTES: AppRouteDefinition[] = [
  { path: '/reporte', label: 'Reporte' },
  { path: '/chat', label: 'Chat' },
  { path: '/patrones', label: 'Patrones' },
  { path: '/historial', label: 'Historial' },
  { path: '/estilo', label: 'Estilo' },
  { path: '/clasificaciones', label: 'Clasificaciones' },
  { path: '/rendimiento', label: 'Rendimiento' },
  { path: '/casos', label: 'Casos' },
  { path: '/suscripcion', label: 'Suscripción' },
  { path: '/ajustes', label: 'Ajustes' },
  { path: '/admin', label: 'Admin' },
]

export const FALLBACK_ROUTE: AppRouteDefinition = {
  path: '*',
  label: 'Fallback',
}

export const ROUTE_PATHS = {
  landing: PUBLIC_ROUTES[0].path,
  login: PUBLIC_ROUTES[1].path,
  resetPassword: PUBLIC_ROUTES[2].path,
  onboarding: ONBOARDING_ROUTE.path,
  reporte: PROTECTED_APP_ROUTES[0].path,
  chat: PROTECTED_APP_ROUTES[1].path,
  patrones: PROTECTED_APP_ROUTES[2].path,
  historial: PROTECTED_APP_ROUTES[3].path,
  estilo: PROTECTED_APP_ROUTES[4].path,
  clasificaciones: PROTECTED_APP_ROUTES[5].path,
  rendimiento: PROTECTED_APP_ROUTES[6].path,
  casos: PROTECTED_APP_ROUTES[7].path,
  suscripcion: PROTECTED_APP_ROUTES[8].path,
  ajustes: PROTECTED_APP_ROUTES[9].path,
  admin: PROTECTED_APP_ROUTES[10].path,
  fallback: FALLBACK_ROUTE.path,
} as const

export function getAllRoutePaths(): string[] {
  return [
    ...PUBLIC_ROUTES.map(route => route.path),
    ONBOARDING_ROUTE.path,
    ...PROTECTED_APP_ROUTES.map(route => route.path),
    FALLBACK_ROUTE.path,
  ]
}
